import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { CerrixTitleComponent } from "@app/shared/atoms/cerrix-title/cerrix-title.component";
import { CerrixWorkflowBarComponent } from "@app/shared/cerrix-workflow-bar/cerrix-workflow-bar.component";
import { WorkflowStepItemModel } from "@app/shared/cerrix-workflow-bar/models/workflow-step-item";
import { CerrixBreadcrumbComponent } from "@app/shared/molecules/cerrix-breadcrumb/cerrix-breadcrumb.component";

@Component({
    selector: "app-cerrix-header",
    templateUrl: "./cerrix-header.component.html",
    styleUrls: ["./cerrix-header.component.scss"],
    imports: [CerrixTitleComponent, CerrixWorkflowBarComponent, CerrixBreadcrumbComponent],
    encapsulation: ViewEncapsulation.None,
})
export class CerrixHeaderComponent {
    @Input() title: string;
    @Input() titlePlaceholder: string;
    @Input() edit: boolean = false;
    @Input() public workflowSteps: WorkflowStepItemModel[] = [];
    @Input() public breadcrumbs: string[] = [];

    @Output() titleChange: EventEmitter<string> = new EventEmitter<string>();
}
